import { LitElement, html, css, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized } from "@lit/localize";

import "@wh-web-front-end/wh-component-library/dist/elements/wh-button";
import type { PrivacyContent } from "../types/content";

@localized()
@customElement("web-kiosk-card-secondary")
export class WebKioskCardSecondaryElement extends LitElement {
  @property() content: PrivacyContent | undefined = undefined;

  render(): TemplateResult {
    return html`
      <article>
        <section>
          <slot name="left"></slot>
        </section>
        <section>
          <slot name="right"></slot>
        </section>
      </article>
    `;
  }

  /* Stryker disable next-line StringLiteral */
  static styles = css`
    :host {
      --web-kiosk-card-secondary-background: #d6efff;
      --web-kiosk-card-secondary-border-radius: 8px;
      --wh-color-surface-primary: #f5f5f0;
      --wh-dimension-radius-m: 8px;
      --wh-dimension-separator-s: 1px;
      --wh-dimension-spacer-xs: 16px;
      --wh-dimension-spacer-s: 24px;
      --wh-dimension-spacer-m: 32px;
      --wh-typography-body-fontFamily: "Source Sans Pro", helvetica, arial;
      --wh-typography-body-fontSize: 24px;
      --wh-typography-h2-fontFamily: "Source Sans Pro", helvetica, arial;
      --wh-typography-h2-fontSize: 32px;
    }

    article {
      align-items: center;
      background-color: var(--web-kiosk-card-secondary-background, hotpink);
      border-radius: var(--wh-dimension-radius-m);
      display: flex;
      flex-direction: row;
      margin: auto var(--wh-dimension-spacer-xs);
      min-height: 160px;
      padding: 0 var(--wh-dimension-spacer-m) 0
        calc(var(--wh-dimension-spacer-xs) + var(--wh-dimension-spacer-s));
      position: relative;
      justify-content: space-between;
    }

    article::before {
      background-color: var(--wh-color-surface-primary, hotpink);
      border-radius: var(--web-kiosk-card-secondary-border-radius);
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: calc(var(--web-kiosk-card-secondary-border-radius) * 2);
    }
  `;
}
